import type { EventData, FeeStructure, VenueData, WidgetBookingPath } from '../types';
import { tierEligibleForTicketCheckout } from './feeTierDesignation';
import { isWidgetTableReservationOnly } from './tableReservationEligibility';

/** Event + venue qualify for the widget table-reservation flow (maps, checkout, etc.). */
export function hasWidgetTableReservationPath(
  event: EventData | null | undefined,
  venue: VenueData | null | undefined,
): boolean {
  return isWidgetTableReservationOnly(event, venue);
}

/** At least one ticket tier is configured for the Tickets path (respects designation when seated). */
export function hasWidgetTicketTiers(
  event: EventData | null | undefined,
  feeStructures: FeeStructure[] | null | undefined,
): boolean {
  if (!Array.isArray(feeStructures) || feeStructures.length === 0) return false;
  if (!event?.seated_event) return true;
  return feeStructures.some((f) => tierEligibleForTicketCheckout(f.designation));
}

/** Both table reservation and ticket purchase are available — show the Tickets / Tables switch. */
export function isWidgetHybridBooking(
  event: EventData | null | undefined,
  venue: VenueData | null | undefined,
  feeStructures: FeeStructure[],
): boolean {
  return hasWidgetTableReservationPath(event, venue) && hasWidgetTicketTiers(event, feeStructures);
}

/**
 * True when the UI should run the table-reservation flow (vs standard ticket flow).
 * For hybrid events, follows `widgetBookingPath`.
 */
export function isWidgetInTablePath(
  hasTablePath: boolean,
  hasTicketTiers: boolean,
  widgetBookingPath: WidgetBookingPath,
): boolean {
  if (!hasTablePath) return false;
  if (!hasTicketTiers) return true;
  return widgetBookingPath === 'tables';
}
